import 'string.prototype.replaceall/auto';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { shouldUseEtaApp } from './etaHost';
import HellotracksApp from './HellotracksApp';
import './index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import './styles/mapbox.css';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';
import RecoilAccessProvider from './providers/RecoilAccessProvider';
import { BrowserRouter } from 'react-router-dom';
import { getDesktopAppVersion, isDesktopEnvironment, tauriReady } from './utils/app';
import { lazyNamed } from './utils/lazy';
import { ChunkErrorBoundary } from './providers/ChunkErrorBoundary';


const mainContainer = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(mainContainer);
const EtaApp = lazyNamed(() => import('./EtaApp'), "EtaApp");
const App = shouldUseEtaApp() ? EtaApp : HellotracksApp;

(async () => {
    if (isDesktopEnvironment()) {
        console.log("desktop environment, waiting for tauri to be ready...");
        try {
            await tauriReady(); // <-- wait only on desktop
        } catch (e) {
            console.error(e);
            // optional: render a minimal fallback UI or just proceed
        }
        const appVersion = await getDesktopAppVersion();
        console.log("tauri ready, starting desktop app", "version: " + appVersion);
    }
  
    root.render(
      <RecoilRoot>
        <RecoilAccessProvider />
        <BrowserRouter>
          <ChunkErrorBoundary>
            <Suspense fallback={null}>
              <App />
            </Suspense>
          </ChunkErrorBoundary>
        </BrowserRouter>
      </RecoilRoot>
    );
  
    reportWebVitals();
  })();
